module.exports = __webpack_public_path__ + "img/bad.acf48281.svg";